import { WeatherModelID } from '../../enums';
import mockedRequester from './mockedRequester';
const mockedResults = {
    RR: { '0': 1 },
    DD: { '0': 180 },
    FF: { '0': 20 },
    U: { '0': 90 },
    T: { '0': 6 },
    TN: { '0': 7 },
    TX: { '0': 12.4 },
    T_SOIL: { '0': 8.4 },
    etp: { '0': 1.4 },
    phrase_32char: { '0': "Averses dans l'après-midi" },
    icon_code: { '0': 61440 },
    pop_phrase: { '0': 'pluvieux' }
};
const mockedResultsArray = [
    {
        timestamp: 1612224000,
        RR: 1,
        DD: 180,
        FF: 20,
        U: 90,
        T: 6,
        TN: 7,
        TX: 12.4,
        T_SOIL: 8.4,
        etp: null,
        phrase_32char: "Averses dans l'après-midi",
        icon_code: 61440,
        pop_phrase: 'pluvieux'
    },
    {
        timestamp: 1612227600,
        RR: 1,
        DD: 180,
        FF: 20,
        U: 90,
        T: 6,
        TN: 7,
        TX: 12.4,
        T_SOIL: 8.4,
        etp: 12,
        phrase_32char: "Averses dans l'après-midi",
        icon_code: 61440,
        pop_phrase: 'pluvieux'
    }
];
const mockedWeatherModelTimeFrame = [
    {
        modelId: WeatherModelID.ARPEGE,
        start: `1497427779`,
        end: `1718452800`
    }
];
const mock = {
    getForecastsAsArray: mockedRequester(mockedResultsArray, 'forecasts.getForecasts'),
    getForecasts: mockedRequester(mockedResults, 'forecasts.getForecasts'),
    getWeatherModel: mockedRequester(mockedWeatherModelTimeFrame, 'forecasts.getWeatherModel')
};
export default mock;
